import React, { Component } from 'react' // eslint-disable-line
import { withRouter } from 'react-router-dom'
import SessionService from './session'

const sessionService = SessionService.Instance()

const validate = function(history: any) {
  const isLoggedIn = sessionService.isLogin()
  if (!isLoggedIn && history.location.pathname !== '/login') {
    history.replace('/login')
  }
}

const isLocationChange = (nextProps: any, props: any) => {
  return nextProps.location !== props.location
}

/**
 * Higher-order component (HOC) to wrap restricted pages
 */
export default function authHOC(BaseComponent: any) {
  class Restricted extends Component {
    UNSAFE_componentWillMount() {
      this.checkAuthentication(this.props)
    }

    componentDidUpdate(nextProps: any) {
      if (isLocationChange(nextProps, this.props)) {
        this.checkAuthentication(nextProps)
      }
    }

    checkAuthentication(params: any) {
      const { history } = params
      validate(history)
    }

    render() {
      return <BaseComponent {...this.props} />
    }
  }
  return withRouter(Restricted)
}
